import { useCallback } from "react";
import { useAppDispatch } from "@store/hooks";
import { setWorkspaceDataLoading } from "@store/slices/loadingSlice";

/**
 * Custom hook for managing workspace loading state
 * Can be used for testing or manual control of loading state
 */
export const useWorkspaceLoading = () => {
  const dispatch = useAppDispatch();

  const setLoading = useCallback(
    (isLoading: boolean) => {
      dispatch(setWorkspaceDataLoading(isLoading));
    },
    [dispatch]
  );

  const startLoading = useCallback(() => {
    dispatch(setWorkspaceDataLoading(true));
  }, [dispatch]);

  const stopLoading = useCallback(() => {
    dispatch(setWorkspaceDataLoading(false));
  }, [dispatch]);

  return {
    setLoading,
    startLoading,
    stopLoading,
  };
};
